module.exports = __webpack_public_path__ + "img/11.07d1745c.jpg";